export const scenarioMap = new Map();